import React, { useState, useEffect } from "react";
import {
  Button,
  Col,
  Card,
  CardBody,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
  ModalHeader,
  Spinner,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane
} from "reactstrap";

import { Client, Databases } from "appwrite";
import getFrenchTag from "../../helpers/local_text_helper";
import { withTranslation } from "react-i18next";
import {
  createLog,
  fetchFBAccessToken,
  fetchFBPagesList,
  fetchFBPostsList,
  fetchFBSubscribeToWebhook,
  formatDateHours,
  getStripeSubscriptionPlanPriceId,
  updateUserData
} from "../../helpers/api_helper";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";
import PlusOutlined from "../../assets/images/icons/PlusOutlined";
import CrossOutlined from "../../assets/images/icons/CrossOutlined";
import SearchOutlined from "../../assets/images/icons/SearchOutlined";
import EditFilled from "../../assets/images/icons/EditFilled";
import TrashFilled from "../../assets/images/icons/TrashFilled";
import Icons from "../../static/icons";
import CustomToast from "../../components/Common/customToast/CustomToast";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import CalculatorModal from "../../components/Common/CalculatorModal/CalculatorModal";
import { useMixpanel } from "../../Hooks/useMixpanel";

import classnames from "classnames";
import CheckCircleRounded from "../../assets/images/icons/CheckCircleRounded";

import errorSm from "../../assets/images/error.png";
import { useFacebook } from "react-facebook";

const FacebookPage = (props) => {
  const navigate = useNavigate();
  const { state } = useLocation();
  console.log({ state });
  const { isUserPlanActive, number_of_ressources } = useSelector((state) => ({
    number_of_ressources: state.subscription.numberOfRessources,
    isUserPlanActive: state.subscription.isUserPlanActive
  }));

  const { mixPanelTrack } = useMixpanel();

  const [toastMessage, setToastMessage] = useState({});
  const [loading, setLoading] = useState(false);
  const [fbAuthLoading, setFBAuthLoading] = useState(false);
  const [toast, setToast] = useState(false);
  const [client_data, setCompanyInfos] = useState(undefined);
  const [fb_pages, setFBPages] = useState(undefined);
  const [fb_selected_pages, setFBSelectedPages] = useState([]);
  const [fb_selected_posts, setFBSelectedPosts] = useState([]);
  const [fb_posts_loading, setFBPostsLoading] = useState(false);
  const [fb_selected_page, setFBSelectedPage] = useState(undefined);
  const [site_infos_more, setSiteInfosMore] = useState("");
  const [modal_list, setmodal_list] = useState(false);
  const [modal_list_edit, setmodal_list_edit] = useState(false);
  const [modal_topics, setModal_topics] = useState(false);
  const [modal_delete_confirm, setModal_DeleteConfirm] = useState(false);
  // let setMyNewList = [];
  const [topicList, setTopicList] = useState([]);
  const [ressourcesList, setRessourcesList] = useState(undefined);
  const [topics_to_show, setTopicsToShow] = useState([]);
  const [topics_to_delete, setTopicsToDelete] = useState(undefined);
  // const [itemStates, setItemStates] = useState(Array(myList.length).fill({ spanVisible: false, buttonDisabled: false, element_loading: false }));
  const [itemStates, setItemStates] = useState([]);
  const [tooltip, setTooltip] = useState(undefined);
  const [show_calculator, showCalculator] = useState(false);
  const [resourceMessage, setResourceMessage] = useState(undefined);

  const [isFbConnected, setIsFbConnected] = useState(undefined);
  const [pageDropdown, setPageDropdown] = useState(false);
  const [selectedPage, setSelectedPage] = useState(undefined);
  const [commentActions, setCommentActions] = useState({});
  const [visibleDropdown, setVisibleDropdown] = useState(false);
  const [selectedFBPageDropdown, setselectedFBPageDropdown] = useState(false);
  const [isFilterDropdown, setIsFilterDropdown] = useState(false);

  const [recherche, setRecherche] = useState("");

  const toggleVerticalIcon = (tab) => {
    if (verticalActiveTabWithIcon !== tab) {
      setverticalActiveTabWithIcon(tab);
    }
  };

  const [verticalActiveTabWithIcon, setverticalActiveTabWithIcon] =
    useState("1");

  // const onShowCalculator = () => {
  //   showCalculator(!show_calculator);
  // };

  const handleClick = (val, mod) => {
    // Remplacez cela par la valeur que vous souhaitez passer
    navigate(`/settings`, {
      replace: true,
      state: { tab: val, modal: mod ?? "" }
    });
  };

  //
  const formik = useFormik({
    initialValues: {
      status_field: "",
      customername_field: ""
    },
    validationSchema: Yup.object({
      status_field: Yup.string().required("Veuillez sélectionner un tag."),
      customername_field: Yup.string()
        .required("add-res_error_msg_2")
        .max(500, "add-res_error_msg_3")
    }),
    onSubmit: (values) => {
      handleModalUpdate();
    }
  });

  // if (loading) {
  //     console.log("toto is: already loading", loading);
  // } else {

  // };

  function tog_list() {
    setmodal_list(!modal_list);
    if (modal_list) {
      if (!formik.isValid) {
        formik.resetForm(formik.initialValues);
      }
      if (state && state.alert_id) {
        navigate("/resources", {
          replace: true,
          state: null
        });
      }
    }
  }

  const tags = [
    "product",
    // "product_availability",
    // "product_advice",
    // "product_problems",
    // "product_price",
    // "promotions",
    // "order_process",
    "order",
    "payments",
    "refunds",
    // "disputes",
    // "billing",
    "delivery",
    "returns",
    "customer_account",
    // "password",
    // "security",
    // "privacy",
    // "customer_data",
    // "after_sales",
    // "technical_problems",
    // "website_feedback",
    // "special_programs",
    // "affiliation",
    "customer_loyalty",
    "feedback",
    // "complaints",
    "company_information",
    // "ethics_social_responsibility",
    // "subscription_management",
    // "store_services",
    "influencers"
    // "content_creators",
    // "spam",
    // "other",
    // "Treated",
    // "Untreated",
  ];

  const statusList = tags.map((tag, index) => {
    return {
      id: index + 1,
      statusName: tag
    };
  });

  const [modalInfo, setModalInfo] = useState({
    id: "", // Initialisez ces valeurs à vide
    statusText: "",
    information: "",
    date: ""
  });

  const handleModalUpdate = async () => {
    // Créez une nouvelle entrée à partir de modalInfo
    const newItem = {
      id: Date.now(),
      statusText: modalInfo.statusText,
      information: modalInfo.information,
      date: Date.now()
    };

    const updatedList = [...topicList, newItem];
    setItemStates(
      Array(updatedList.length).fill({
        spanVisible: false,
        buttonDisabled: false,
        element_loading: false
      })
    );
    console.log(updatedList);
    setTopicList(updatedList);
    setModalInfo({
      id: "", // Initialisez ces valeurs à vide
      statusText: "",
      information: "",
      date: ""
    });

    const response = await updateCompanyInfos(updatedList);
    if (!response) {
      onLoadingChanged(false);
      return;
    }

    if (state && state.alert_id) {
      await updateAlert(state.alert_id);
    }
    tog_list();
    onRessourceListChanged(client_data.contact_reasons, updatedList);
    // Créer le log
    var user_id = JSON.parse(localStorage.getItem("authUser")).userId;
    let logData = {
      eventCreatedAt: response?.$createdAt,
      author_id: user_id,
      company_id: client_data.$id,
      topic_tag: newItem.statusText,
      topic_id: newItem.id
    };
    let logdata = {
      event: "topic_added",
      author_id: user_id,
      company_id: client_data.$id,
      log_data: JSON.stringify(logData)
    };
    createLog(logdata, mixPanelTrack);
    setToastMessage({
      header: props.t("Succès"),
      body: props.t("Modifications effectuées"),
      key: "success"
    });
    console.log("response message: ", response);
    onLoadingChanged(false);
    toggleToast();
  };

  const saveElementData = async () => {
    console.log("saveElementData clicked");
    const response = await updateCompanyInfos(topicList);
    if (!response) {
      onLoadingChanged(false);
      return;
    }
    // Créer le log
    var user_id = JSON.parse(localStorage.getItem("authUser")).userId;
    let logData = {
      eventCreatedAt: response?.$createdAt,
      author_id: user_id,
      company_id: client_data.$id,
      topic_tag: editItem.statusText,
      topic_id: editItem.id
    };
    let logdata = {
      event: "topic_updated",
      author_id: user_id,
      company_id: client_data.$id,
      log_data: JSON.stringify(logData)
    };
    createLog(logdata, mixPanelTrack);
    setToastMessage({
      header: props.t("Succès"),
      body: props.t("Modifications effectuées"),
      key: "success"
    });
    console.log("response message: ", response);
    onLoadingChanged(false);
    toggleToast();
  };

  async function updateCompanyInfos(data) {
    const client = new Client();
    const databases = new Databases(client, "default");

    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    const promise = databases.updateDocument(
      "default",
      "client_infos",
      localStorage.getItem("companyId"),
      {
        company_data: data.map((item) => JSON.stringify(item, null, 4))
      }
    );
    return promise.then(
      async function (response) {
        console.log(response); // Success
        return response;
      },
      function (error) {
        onDeleteLoadingChanged(false);
        setToastMessage({
          header: props.t("Echec"),
          body: error.message,
          key: "danger"
        });
        toggleToast();
        console.log(error); // Failure
        return null;
      }
    );
  }

  const toggleToast = () => {
    console.log("setToast before: " + toast);
    setToast(true);
    console.log("setToast after: " + toast);

    setTimeout(() => {
      setToast(false);
    }, 3000);
  };

  const onLoadingChanged = (val) => {
    setLoading(val);
  };

  const onFBAuthLoadingChanged = (val) => {
    setFBAuthLoading(val);
  };

  const onRessourceListChanged = (val, topic_list) => {
    let completeTagList = [...val];
    (topic_list ?? topicList).forEach((topic) => {
      if (!completeTagList.includes(topic.statusText)) {
        completeTagList.push(topic.statusText);
      }
    });
    setRessourcesList(completeTagList);
  };

  const onTopicListChanged = (val) => {
    setTopicList(val);
  };

  useEffect(() => {
    getClientData();
  }, []);

  useEffect(() => {
    if (fb_selected_page) {
      getFBPostList(fb_selected_page.id, fb_selected_page.access_token);
    }
  }, [fb_selected_page]);

  // modal

  const [editItem, setTopicToEdit] = useState({ information: "" });
  function tog_list_edit() {
    setmodal_list_edit(!modal_list_edit);
  }

  const onEditTopic = (item) => {
    setTopicToEdit(item);
  };

  const [deleteLoading, setDeleteLoading] = useState({});
  const [addLoading, setAddLoading] = useState(false);

  const onDeleteLoadingChanged = (item) => {
    setDeleteLoading(item);
  };
  // modal topics
  function tog_topics() {
    setModal_topics(!modal_topics);
  }

  function tog_delete(data) {
    setTopicsToDelete(data);
    setModal_DeleteConfirm(!modal_delete_confirm);
  }

  async function updateAlert(alert_id) {
    // console.log("updateAlert", alert_id);
    const client = new Client();
    const databases = new Databases(client, "default");
    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);
    try {
      await databases.updateDocument("default", "alert", alert_id, {
        active: false
      });
      // console.log("Alert deleted successfully");
    } catch (error) {
      console.log("Error updating alert:", error);
    }
  }

  //   useEffect(() => {
  //     if (state && state.alert_id) {
  //       tog_list();
  //     }
  //   }, [state]);

  //   const [numberOfRessources, setNumberOfRessources] = useState(0);

  //   useEffect(() => {
  //     if (isUserPlanActive) {
  //       setNumberOfRessources(number_of_ressources);
  //     } else {
  //       setNumberOfRessources(0);
  //     }
  //   }, [isUserPlanActive, number_of_ressources]);

  function onFbConnected(val) {
    toggleVerticalIcon(val === true ? "1" : "2");
    setIsFbConnected(val);
  }

  const { isLoading, init, error } = useFacebook();

  async function handleLogin() {
    const api = await init();

    // const response = await api.login();
    const FB = await api.getFB(); // Get original FB object

    FB.login(
      function (response) {
        console.log(response);
        if (response.authResponse) {
          handleFBLoginSuccess(response.authResponse);
        }
      },
      {
        config_id: "575923421469247",
        response_type: "code",
        override_default_response_type: true
      }
    );
  }

  async function handleFBLoginSuccess(auth) {
    onFBAuthLoadingChanged(true);
    const code = auth.code;

    try {
      const access_token_response = await fetchFBAccessToken(code);

      await updateUserData(localStorage.getItem("companyId"), {
        fb_user_id: access_token_response.user_id,
        fb_access_token: access_token_response.access_token
      });

      const response = await fetchFBPagesList(
        access_token_response.access_token,
        access_token_response.user_id
      );

      setIsFbConnected(true);
      setFBPages(
        response.pages.map((page) => {
          return {
            id: page.id,
            name: page.name,
            category: page.category,
            access_token: page.access_token
          };
        })
      );
      onFBAuthLoadingChanged(false);
    } catch (error) {
      onFBAuthLoadingChanged(false);
    }
  }

  const getClientData = async function () {
    onLoadingChanged(true);
    const client = new Client();
    const databases = new Databases(client, "default");

    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    const promise = databases.getDocument(
      "default",
      "client_infos",
      localStorage.getItem("companyId")
    );

    promise.then(
      async function (response) {
        console.log("getClientData", response);
        const clientInfos = response;
        setCompanyInfos(clientInfos);
        if (clientInfos.fb_access_token) {
          onFbConnected(true);
          const res = await fetchFBPagesList(
            clientInfos.fb_access_token,
            clientInfos.fb_user_id
          );
          var FBSelectedPages = [];

          if (res) {
            const FBPages = res.pages.map((page) => {
              return {
                id: page.id,
                name: page.name,
                category: page.category,
                access_token: page.access_token
              };
            });
            setFBPages(FBPages);
            console.log({
              FBPages
            });

            FBSelectedPages = res.pages
              .filter((page) => clientInfos.fb_pages_id.includes(page.id))
              .map((page) => {
                return {
                  id: page.id,
                  name: page.name,
                  category: page.category,
                  access_token: page.access_token
                };
              });

            setFBSelectedPages(FBSelectedPages);
          }

          console.log({
            FBSelectedPages
          });

          if (FBSelectedPages.length > 0) {
            setFBSelectedPage(FBSelectedPages[0]);
          } else {
            toggleVerticalIcon("2");
          }
        } else {
          onFbConnected(false);
        }
        onLoadingChanged(false);
      },
      function (error) {
        onLoadingChanged(false);
        console.log(error); // Failure
        return null;
      }
    );
  };
  const getFBPostList = async (page_id, access_token) => {
    setFBPostsLoading(true);
    const response = await fetchFBPostsList(page_id, access_token);

    if (!response) {
      return;
    }
    setFBSelectedPosts(response.posts);
    setFBPostsLoading(false);
  };

  const handleAddFBPage = async function (page) {
    setAddLoading(true);
    const updated_pages_id = [...fb_selected_pages.map((p) => p.id), page.id];
    const res = await updateUserData(localStorage.getItem("companyId"), {
      fb_pages_id: updated_pages_id
    });
    const result = await fetchFBSubscribeToWebhook(page.id, page.access_token);

    if (!res) {
      setAddLoading(false);
      return;
    }
    if (fb_selected_pages.length === 0) {
      setFBSelectedPage(page);
    }
    setFBSelectedPages([...fb_selected_pages, page]);
    setAddLoading(false);
  };

  const handleRemoveFBPage = async function (page_id) {
    setDeleteLoading({ ...deleteLoading, [page_id]: true });
    const updated_pages_id = fb_selected_pages
      .filter((p) => p.id !== page_id)
      .map((p) => p.id);
    const res = await updateUserData(localStorage.getItem("companyId"), {
      fb_pages_id: updated_pages_id
    });
    if (!res) {
      setDeleteLoading({ ...deleteLoading, [page_id]: false });
      return;
    }
    setFBSelectedPages(fb_selected_pages.filter((p) => p.id !== page_id));
    setDeleteLoading({ ...deleteLoading, [page_id]: false });
  };
  return (
    <React.Fragment>
      <div
        className="page-content ressources-content settings-content"
        style={{ paddingLeft: "0" }}
      >
        <Modal
          isOpen={modal_topics}
          toggle={tog_topics}
          centered
          className="help-page-modal modal_wrapper__100x100"
        >
          <ModalBody
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100%"
            }}
          >
            <Button
              className="close_button"
              style={{
                backgroundColor: "transparent",
                border: "none",
                padding: "0px",
                position: "absolute",
                right: "1rem"
              }}
              onClick={() => {
                tog_topics();
              }}
            >
              <CrossOutlined height={26} />
            </Button>
            <h1
              className="modal_title"
              style={{ marginTop: "4%", marginBottom: "4%" }}
            >
              {props.t("Ressources")}
            </h1>
            <Row
              className="gap-4 mb-5"
              style={{
                marginLeft: "8%",
                marginRight: "8%",
                flex: "1",
                overflow: "auto"
              }}
            >
              <Col
                xl={12}
                className="d-flex gap-3"
                style={{
                  flexDirection: "column"
                }}
              >
                {topics_to_show.length > 0 ? (
                  topics_to_show.map((topic, index) => (
                    <div
                      key={index}
                      className="help-page-modal-button d-flex align-items-center justify-content-between"
                    >
                      <div className="d-flex flex-column col-10">
                        <h3>{props.t(topic.statusText)}</h3>
                        <p
                          className="m-0 simple-text font-primary fw-normal"
                          style={{
                            overflow: "hidden",
                            display: "-webkit-box",
                            "-webkit-box-orient": "vertical",
                            "-webkit-line-clamp": "2"
                          }}
                        >
                          {topic.information}
                        </p>
                      </div>
                      <div className="d-flex" style={{ flexWrap: "nowrap" }}>
                        <Button
                          className="me-xxl-2 me-xl-1"
                          style={{
                            backgroundColor: "transparent",
                            border: "none"
                          }}
                          onClick={() => {
                            onEditTopic(topic);
                            tog_list_edit();
                          }}
                        >
                          <EditFilled
                            style={{ color: "#329993" }}
                            height={26}
                          />
                        </Button>
                        {deleteLoading === topic.id ? (
                          <Spinner animation="border" className="" />
                        ) : (
                          <Button
                            style={{
                              backgroundColor: "transparent",
                              border: "none",
                              padding: "0"
                            }}
                            onClick={() => tog_delete(topic)}
                          >
                            <TrashFilled
                              height={26}
                              style={{ color: "#F10944" }}
                            />
                          </Button>
                        )}
                      </div>
                    </div>
                  ))
                ) : (
                  <div
                    className="font-primary text-center"
                    style={{ fontSize: "18px" }}
                  >
                    {props.t("Vide")}
                  </div>
                )}
              </Col>
            </Row>
          </ModalBody>
          <div
            className="position-fixed bottom-0 end-0 p-3"
            style={{ zIndex: "1005" }}
          >
            <CustomToast
              isOpen={toast}
              toggle={toggleToast}
              message={toastMessage}
            />
          </div>
        </Modal>

        <Row>
          <Col
            xs="12"
            xxl={9}
            xl={11}
            className="mx-auto"
            style={{
              marginTop: "60px"
            }}
          >
            <div className="ps-0 pe-0 page-title-box d-sm-flex align-items-center justify-content-between">
              <div
                className="d-flex flex-column"
                style={{ width: "fit-content" }}
              >
                <h4
                  className="page-title font-primary"
                  style={{ fontSize: "14px" }}
                >
                  <i
                    className="mdi mdi-facebook me-1"
                    style={{ fontSize: "25px", color: "#563BFF" }}
                  />{" "}
                  {props.t("Facebook")}
                </h4>
                <p
                  className="mb-0 mt-2 simple-text font-primary"
                  style={{
                    color: "#666969",
                    fontStyle: "normal",
                    fontWeight: "400",
                    fontSize: "14px"
                  }}
                >
                  {props.t(
                    "Avec Synibox, gérez les commentaires que les personnes envoient à votre Facebook"
                  )}
                </p>
              </div>
            </div>
          </Col>
        </Row>
        {/* <CalculatorModal
          isOpen={show_calculator}
          toggle={onShowCalculator}
          upgrade_downgrade={true}
        /> */}

        {/* Add Modal */}
        <Modal isOpen={modal_list} toggle={tog_list} centered>
          <ModalHeader
            className="bg-light p-3"
            id="exampleModalLabel"
            toggle={tog_list}
          >
            {props.t("Ajouter une ressource")}
          </ModalHeader>
          <form className="tablelist-form">
            <ModalBody>
              <div>
                <label htmlFor="status_field" className="form-label">
                  {props.t("Catégories")}
                </label>
                <select
                  className={`form-control ${
                    formik.touched.status_field &&
                    formik.errors.status_field &&
                    "border border-danger"
                  }`}
                  data-trigger
                  name="status_field"
                  id="status_field"
                  value={modalInfo.statusText}
                  onBlur={formik.handleBlur}
                  onChange={(e) => {
                    formik.handleChange(e);
                    setModalInfo({
                      ...modalInfo,
                      statusText: e.target.value
                      //   information: e.target.value,
                    });
                  }}
                >
                  <option value="" disabled>
                    {props.t("Aucun")}
                  </option>
                  {statusList.map((item, index) => (
                    <option key={index} value={item.statusName}>
                      {props.t(item.statusName)}
                    </option>
                  ))}
                </select>
                {formik.touched.status_field && formik.errors.status_field && (
                  <span className="font-primary text-danger">
                    {props.t("add-res_error_msg_1")}
                  </span>
                )}
              </div>
              <div className="my-3">
                <label htmlFor="customername_field" className="form-label">
                  {props.t("Informations")}
                </label>
                <textarea
                  id="customername_field"
                  name="customername_field"
                  style={{
                    border: "none",
                    position: "relative" // Rendre le textarea positionnel
                  }}
                  required
                  className={`text-area col-12 form-control ${
                    formik.touched.customername_field &&
                    formik.errors.customername_field &&
                    "border border-danger"
                  }`}
                  placeholder={props.t("Entrer les informations")}
                  rows="3"
                  cols="45"
                  value={modalInfo.information}
                  onBlur={formik.handleBlur}
                  onChange={(e) => {
                    formik.handleChange(e);
                    setModalInfo({ ...modalInfo, information: e.target.value });
                  }}
                ></textarea>
                {
                  <span
                    className={`font-primary mt-1 ${
                      formik.touched.customername_field &&
                      formik.errors.customername_field
                        ? "text-danger"
                        : ""
                    }`}
                    style={{ float: "right" }}
                  >{`${modalInfo.information.length}/500`}</span>
                }
                {formik.touched.customername_field &&
                  formik.errors.customername_field && (
                    <span className="font-primary text-danger">
                      {props.t(formik.errors.customername_field)}
                    </span>
                  )}
              </div>
            </ModalBody>
            <ModalFooter>
              <div
                className="hstack gap-2 justify-content-end"
                style={{ width: "100%" }}
              >
                <button
                  type="button"
                  className="view-button "
                  style={{ color: "black", width: "100%" }}
                  onClick={tog_list}
                >
                  {props.t("Annuler")}
                </button>
                <button
                  type="button"
                  className="view-button "
                  style={{ backgroundColor: "#563bff", width: "100%" }}
                  id="edit-btn"
                  onClick={() => {
                    formik.handleSubmit();
                  }}
                >
                  {props.t("Ajouter")}
                </button>
              </div>
            </ModalFooter>
          </form>
        </Modal>
        <div
          className="position-fixed bottom-0 end-0 p-3"
          style={{ zIndex: "1005" }}
        >
          <CustomToast
            isOpen={toast}
            toggle={toggleToast}
            message={toastMessage}
          />
        </div>

        {/* Edit Modal */}
        <Modal isOpen={modal_list_edit} toggle={tog_list_edit} centered>
          <ModalHeader
            className="bg-light p-3"
            id="exampleModalLabel"
            toggle={tog_list_edit}
          >
            {props.t("Modifier la ressource")}
          </ModalHeader>
          <form className="tablelist-form">
            <ModalBody>
              <div className="mb-3 d-flex flex-column">
                <label htmlFor="customername-field" className="form-label">
                  {props.t("Informations")}
                </label>
                <textarea
                  id="customername-field"
                  style={{
                    border: "none",
                    position: "relative", // Rendre le textarea positionnel
                    minHeight: "300px"
                  }}
                  required
                  className={`text-area col-12 form-control ${
                    editItem &&
                    editItem.information.length > 500 &&
                    "border border-danger"
                  }`}
                  rows="3"
                  cols="45"
                  value={editItem.information}
                  onChange={(e) => {
                    const updatedList = [...topicList];
                    const foundIndex = updatedList.findIndex(
                      (item) => item.id === editItem.id
                    );
                    updatedList[foundIndex].information = e.target.value;
                    setTopicList(updatedList);
                  }}
                ></textarea>
                <div className="">
                  {editItem && editItem.information.length > 500 && (
                    <span className="font-primary text-danger">
                      {props.t("add-res_error_msg_3")}
                    </span>
                  )}
                  <span
                    style={{ float: "right" }}
                    className={`font-primary mt-1 ${
                      editItem && editItem.information.length > 500
                        ? "text-danger"
                        : ""
                    }`}
                  >{`${editItem && editItem.information.length}/500`}</span>
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <div
                className="hstack gap-2 justify-content-end"
                style={{ width: "100%" }}
              >
                <button
                  type="button"
                  className="view-button "
                  style={{ color: "black", width: "100%" }}
                  onClick={tog_list_edit}
                >
                  {props.t("Annuler")}
                </button>
                <button
                  type="button"
                  className="view-button "
                  disabled={editItem && editItem.information.length > 500}
                  id="edit-btn"
                  style={{
                    backgroundColor: "#563bff",
                    width: "100%",
                    cursor:
                      editItem && editItem.information.length > 500
                        ? "not-allowed"
                        : "pointer"
                  }}
                  onClick={() => {
                    saveElementData();
                    tog_list_edit();
                    toggleToast();
                  }}
                >
                  {props.t("Modifier")}
                </button>
              </div>
            </ModalFooter>
          </form>
        </Modal>

        <Row>
          <Col
            xs="12"
            xxl={9}
            xl={11}
            className="mx-auto"
            style={{
              marginTop: "20px",
              marginBottom: "20px"
            }}
          >
            <Card
              className="settings-menu"
              style={{
                display: "flex",
                backgroundColor: "transparent",
                boxShadow: "none",
                marginBottom: "0px",
                justifyContent: "center"
              }}
            >
              <CardBody style={{ padding: "0px" }}>
                <Nav
                  pills
                  className="flex-row"
                  style={{ height: "fit-content", width: "fit-content" }}
                >
                  <NavItem>
                    <NavLink
                      id="v-pills-left-home-tab"
                      style={{ cursor: "pointer" }}
                      disabled={
                        isFbConnected === true && fb_selected_pages.length > 0
                          ? false
                          : true
                      }
                      className={classnames(
                        {
                          active: verticalActiveTabWithIcon === "1"
                        },
                        "font-primary"
                      )}
                      onClick={() => {
                        toggleVerticalIcon("1");
                      }}
                    >
                      <div className="d-flex flex-wrap gap-2">
                        <span>{props.t("Commentaires")} </span>
                      </div>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      id="v-pills-left-home-tab"
                      style={{ cursor: "pointer" }}
                      className={classnames(
                        {
                          active: verticalActiveTabWithIcon === "2"
                        },
                        "font-primary"
                      )}
                      onClick={() => {
                        toggleVerticalIcon("2");
                      }}
                    >
                      <div className="d-flex flex-wrap gap-2">
                        <svg
                          width="15"
                          height="15"
                          style={{ marginTop: "3px" }}
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M19.1471 4.73876C19.19 4.18931 19.0044 3.6465 18.6339 3.23846C18.4238 3.00706 18.1159 2.82927 17.5 2.47368C16.8841 2.11809 16.5762 1.9403 16.2707 1.87406C15.7321 1.75725 15.1692 1.86787 14.7148 2.1798C14.4572 2.3567 14.2394 2.6378 13.8039 3.2C13.3831 3.74315 12.7031 4.0014 12.0161 4.00005C12.0107 4.00004 12.0054 4.00004 12 4.00004C11.9946 4.00004 11.9891 4.00004 11.9837 4.00005C11.2967 4.00142 10.6168 3.74321 10.1961 3.20015C9.76058 2.63795 9.54281 2.35684 9.28515 2.17995C8.8308 1.86802 8.26788 1.7574 7.72928 1.87421C7.42384 1.94045 7.11589 2.11824 6.5 2.47383C5.8841 2.82942 5.57615 3.00721 5.36607 3.23861C4.99561 3.64664 4.80995 4.18946 4.85291 4.7389C4.87727 5.05049 5.01183 5.37963 5.28093 6.0379C5.54099 6.67405 5.42354 7.39207 5.07823 7.98627C5.07263 7.99592 5.06705 8.00557 5.06149 8.01524C4.71924 8.60989 4.15689 9.06955 3.47708 9.16226C2.77242 9.25835 2.4201 9.30639 2.13807 9.44108C1.64076 9.6786 1.2635 10.1108 1.09535 10.6356C1 10.9333 1 11.2889 1 12C1 12.7112 1 13.0668 1.09535 13.3644C1.2635 13.8893 1.64076 14.3215 2.13807 14.559C2.4201 14.6937 2.77242 14.7417 3.47708 14.8378C4.1569 14.9305 4.71924 15.3902 5.06149 15.9848C5.06705 15.9945 5.07264 16.0042 5.07824 16.0138C5.42354 16.608 5.541 17.326 5.28094 17.9621C5.01183 18.6204 4.87728 18.9496 4.85291 19.2612C4.80995 19.8106 4.99561 20.3534 5.36607 20.7615C5.57616 20.9929 5.8841 21.1707 6.5 21.5262C7.11589 21.8818 7.42384 22.0596 7.72928 22.1259C8.26788 22.2427 8.8308 22.132 9.28515 21.8201C9.54281 21.6432 9.76058 21.3621 10.1961 20.7999C10.6168 20.2569 11.2967 19.9986 11.9837 20C11.9891 20 11.9946 20 12 20C12.0054 20 12.0107 20 12.0161 20C12.7031 19.9987 13.3831 20.2569 13.8039 20.8001C14.2394 21.3623 14.4572 21.6434 14.7148 21.8203C15.1692 22.1322 15.7321 22.2428 16.2707 22.126C16.5762 22.0598 16.8841 21.882 17.5 21.5264C18.1159 21.1708 18.4238 20.993 18.6339 20.7616C19.0044 20.3536 19.19 19.8108 19.1471 19.2613C19.1227 18.9497 18.9882 18.6206 18.719 17.9623C18.459 17.3261 18.5764 16.608 18.9218 16.0138C18.9274 16.0041 18.9329 15.9945 18.9385 15.9849C19.2808 15.3902 19.8431 14.9305 20.5229 14.8378C21.2276 14.7417 21.5799 14.6937 21.8619 14.559C22.3592 14.3215 22.7365 13.8893 22.9046 13.3644C23 13.0668 23 12.7112 23 12C23 11.2889 23 10.9333 22.9046 10.6356C22.7365 10.1108 22.3592 9.6786 21.8619 9.44109C21.5799 9.30639 21.2276 9.25835 20.5229 9.16226C19.8431 9.06955 19.2808 8.60989 18.9385 8.01523C18.933 8.00557 18.9274 7.99593 18.9218 7.9863M12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 11.6494 9.06015 11.3128 9.17071 11"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <span>{props.t("Paramètre")} </span>
                      </div>
                    </NavLink>
                  </NavItem>
                </Nav>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col xs="12" xxl={9} xl={11} className="mx-auto">
            <TabContent
              activeTab={verticalActiveTabWithIcon}
              className="text-muted mt-4 mt-md-0"
            >
              <TabPane tabId="1">
                {!loading &&
                  fb_selected_pages &&
                  fb_selected_pages.length > 0 && (
                    <div>
                      <Card
                        className="user-card font-primary"
                        style={{
                          borderLeft: "5px solid #563BFF",
                          marginBottom: "15px",
                          borderRadius: "10px",
                          boxShadow: "0px 6px 24px 1px rgba(53, 22, 252, 0.1)",
                          paddingTop: "6px",
                          paddingRight: "29px",
                          paddingBottom: "10px",
                          paddingLeft: "16px"
                        }}
                      >
                        <CardBody className="p-0">
                          <Row>
                            <Col md={4} className="d-flex align-items-center">
                              <div className="d-flex align-items-end gap-2">
                                <div className="d-flex align-items-baseline gap-2">
                                  <div
                                    className="agent-name font-primary"
                                    style={{
                                      width: "fit-content",
                                      color: "#1E222C",
                                      fontSize: "14px",
                                      fontStyle: "normal",
                                      fontWeight: "500",
                                      lineHeight: "38.454px",
                                      position: "relative"
                                    }}
                                  >
                                    <Dropdown
                                      isOpen={visibleDropdown}
                                      toggle={() => {
                                        setVisibleDropdown(!visibleDropdown);
                                      }}
                                    >
                                      <DropdownToggle
                                        tag="button"
                                        className="form-control p-0 m-0"
                                        style={{
                                          textTransform: "capitalize",
                                          border: "none",
                                          backgroundColor: "transparent",
                                          margin: "0",
                                          padding: "0"
                                        }}
                                      >
                                        {"Select visible"}
                                        <i className="ms-2 mdi mdi-chevron-down" />
                                      </DropdownToggle>
                                      <DropdownMenu className="dropdown-menu-lg-end">
                                        <DropdownItem onClick={() => {}}>
                                          v1
                                        </DropdownItem>
                                        <DropdownItem onClick={() => {}}>
                                          v2
                                        </DropdownItem>
                                        <DropdownItem onClick={() => {}}>
                                          v3
                                        </DropdownItem>
                                      </DropdownMenu>
                                    </Dropdown>
                                  </div>
                                </div>
                              </div>
                            </Col>
                            <Col md={2} className="align-items-center">
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px",
                                  fontSize: "16px"
                                }}
                              >
                                {/* Texte et icône de filtre */}
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    cursor: "pointer",
                                    marginRight: "5px"
                                  }}
                                >
                                  <span>Filtre</span>
                                  <Dropdown
                                    isOpen={isFilterDropdown}
                                    toggle={() => {
                                      setIsFilterDropdown(!isFilterDropdown);
                                    }}
                                  >
                                    <DropdownToggle
                                      tag="button"
                                      className="form-control py-0 p-0 m-0"
                                      style={{
                                        textTransform: "capitalize",
                                        border: "none",
                                        backgroundColor: "transparent",
                                        margin: "0",
                                        padding: "0"
                                      }}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="20"
                                        viewBox="0 0 24 24"
                                      >
                                        <path
                                          fill="currentColor"
                                          d="M11 20q-.425 0-.712-.288T10 19v-6L4.2 5.6q-.375-.5-.112-1.05T5 4h14q.65 0 .913.55T19.8 5.6L14 13v6q0 .425-.288.713T13 20zm1-7.7L16.95 6h-9.9zm0 0"
                                        />
                                      </svg>
                                      <i className="ms-2 mdi mdi-chevron-down" />
                                    </DropdownToggle>
                                    <DropdownMenu className="dropdown-menu-lg-end">
                                      <DropdownItem onClick={() => {}}>
                                        f1
                                      </DropdownItem>
                                      <DropdownItem onClick={() => {}}>
                                        f2
                                      </DropdownItem>
                                      <DropdownItem onClick={() => {}}>
                                        f3
                                      </DropdownItem>
                                    </DropdownMenu>
                                  </Dropdown>
                                </div>

                                {/* Icône de tri (haut/bas) */}
                                <div style={{ cursor: "pointer" }}>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                  >
                                    <g fill="currentColor">
                                      <g fill-opacity=".3">
                                        <path d="M7.5 2.286a1 1 0 0 0-1 1v12a1 1 0 1 0 2 0v-12a1 1 0 0 0-1-1" />
                                        <path d="M8.207 2.579a1 1 0 0 0-1.414 0l-3.5 3.5a1 1 0 0 0 1.414 1.414L7.5 4.7l2.793 2.793a1 1 0 1 0 1.414-1.414z" />
                                      </g>
                                      <path d="M16.5 22.286a1 1 0 0 0 1-1v-12a1 1 0 1 0-2 0v12a1 1 0 0 0 1 1" />
                                      <path d="M15.793 21.993a1 1 0 0 0 1.414 0l3.5-3.5a1 1 0 0 0-1.414-1.414L16.5 19.872l-2.793-2.793a1 1 0 0 0-1.414 1.414z" />
                                    </g>
                                  </svg>
                                </div>

                                {/* Icône de recherche */}
                                <div style={{ cursor: "pointer" }}>
                                  <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M21 21L18.4953 18.4953C18.1033 18.1033 17.9073 17.9073 17.7092 17.8311C17.5121 17.7553 17.3684 17.7425 17.161 17.7825C16.9527 17.8226 16.6814 18.0117 16.1387 18.3897C14.6817 19.4048 12.9104 20 11 20C6.02944 20 2 15.9706 2 11C2 6.02944 6.02944 2 11 2C15.9706 2 20 6.02944 20 11C20 12.2414 19.7487 13.4241 19.2941 14.5"
                                      stroke="#2F384C"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                    />
                                  </svg>
                                </div>

                                {/* Icône d'export */}
                                <div style={{ cursor: "pointer" }}>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      fill="currentColor"
                                      d="M20.92 15.62a1.2 1.2 0 0 0-.21-.33l-3-3a1 1 0 0 0-1.42 1.42l1.3 1.29H12a1 1 0 0 0 0 2h5.59l-1.3 1.29a1 1 0 0 0 0 1.42a1 1 0 0 0 1.42 0l3-3a.9.9 0 0 0 .21-.33a1 1 0 0 0 0-.76M14 20H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h4a1 1 0 0 0 .92-.62a1 1 0 0 0-.21-1.09l-6-6a1 1 0 0 0-.28-.19h-.09l-.28-.1H6a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h8a1 1 0 0 0 0-2M13 5.41L15.59 8H14a1 1 0 0 1-1-1Z"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </Col>
                            {fb_selected_pages &&
                              fb_selected_pages.length > 0 && (
                                <Col
                                  md={2}
                                  className="align-items-center ms-auto"
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "10px",
                                      fontSize: "16px"
                                    }}
                                  >
                                    <Dropdown
                                      isOpen={selectedFBPageDropdown}
                                      toggle={() => {
                                        setselectedFBPageDropdown(
                                          !selectedFBPageDropdown
                                        );
                                      }}
                                    >
                                      <DropdownToggle
                                        tag="button"
                                        className="form-control p-0 m-0"
                                        style={{
                                          textTransform: "capitalize",
                                          border: "none",
                                          backgroundColor: "transparent",
                                          margin: "0",
                                          padding: "0"
                                        }}
                                      >
                                        <i
                                          className="mdi mdi-facebook me-1"
                                          style={{ fontSize: "18px" }}
                                        />
                                        {fb_selected_page
                                          ? fb_selected_page.name
                                          : "Select Page"}
                                        <i className="ms-2 mdi mdi-chevron-down" />
                                      </DropdownToggle>

                                      <DropdownMenu className="dropdown-menu-lg-end">
                                        {fb_selected_pages.map((page) => (
                                          <DropdownItem
                                            key={page.id}
                                            onClick={() => {
                                              setFBSelectedPage(page);
                                            }}
                                          >
                                            {page.name}
                                          </DropdownItem>
                                        ))}
                                      </DropdownMenu>
                                    </Dropdown>
                                  </div>
                                </Col>
                              )}
                          </Row>
                        </CardBody>
                      </Card>

                      {fb_selected_posts &&
                        fb_selected_posts.length > 0 &&
                        fb_selected_posts.map((post) => (
                          <div key={post.id}>
                            {post.comments.map((comment) => (
                              <Card
                                key={comment.id}
                                className="user-card font-primary"
                                style={{
                                  borderLeft: "5px solid #563BFF",
                                  marginBottom: "15px",
                                  borderRadius: "10px",
                                  boxShadow:
                                    "0px 6px 24px 1px rgba(53, 22, 252, 0.1)",
                                  paddingTop: "6px",
                                  paddingRight: "29px",
                                  paddingBottom: "10px",
                                  paddingLeft: "16px"
                                }}
                              >
                                <CardBody className="p-0">
                                  <Row>
                                    <Col
                                      md={5}
                                      className="d-flex align-items-center"
                                    >
                                      <div className="row w-100">
                                        <div
                                          className="col-md-3"
                                          style={{ borderRadius: "20px" }}
                                        >
                                          <img
                                            src={post.full_picture || errorSm}
                                            alt="fb_post_full_picture"
                                            width={102}
                                          />
                                        </div>
                                        <div className="col-md-9 flex-row align-items-center mt-3">
                                          <div
                                            style={{
                                              overflow: "hidden",
                                              display: "-webkit-box",
                                              "-moz-box-orient": "vertical",
                                              "-webkit-line-clamp": "2"
                                            }}
                                          >
                                            {post.message}
                                          </div>
                                          <div>
                                            {formatDateHours(
                                              props,
                                              post.created_time
                                            )}
                                          </div>
                                          <div>
                                            <i
                                              className="mdi mdi-facebook me-1"
                                              style={{ fontSize: "18px" }}
                                            />
                                            {fb_selected_page.name}
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                    <Col
                                      md={5}
                                      className="d-flex align-items-center"
                                    >
                                      <div className="simple-text font-primary">
                                        <div>{comment.message}</div>
                                      </div>
                                    </Col>
                                    <Col className="d-flex justify-content-end col-md-full">
                                      <div className="d-flex">
                                        {commentActions[1] &&
                                        commentActions[1].loading ? (
                                          <span
                                            className="spinner-border spinner-border-sm me-2"
                                            role="status"
                                            aria-hidden="true"
                                          ></span>
                                        ) : (
                                          <Dropdown
                                            isOpen={
                                              commentActions[1] &&
                                              commentActions[1].state
                                            }
                                            toggle={() => {
                                              setCommentActions(
                                                (prevState) => ({
                                                  ...prevState,
                                                  1: prevState[1]
                                                    ? {
                                                        state:
                                                          !prevState[1].state,
                                                        loading:
                                                          prevState[1].loading
                                                      }
                                                    : {
                                                        state: true,
                                                        loading: false
                                                      }
                                                })
                                              );
                                            }}
                                            style={{
                                              display: "flex"
                                            }}
                                          >
                                            <DropdownToggle
                                              tag="button"
                                              className={`btn email-menu-dropdown email-menu-dropdown-active                                      `}
                                              style={{
                                                border: "none",
                                                padding: "0",
                                                marginRight: "10px"
                                              }}
                                            >
                                              <svg
                                                width="27"
                                                height="7"
                                                viewBox="0 0 27 7"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <g id="Group 1000002886">
                                                  <circle
                                                    id="Ellipse 1029"
                                                    cx="3"
                                                    cy="3.24402"
                                                    r="3"
                                                    fill="#563BFF"
                                                  />
                                                  <circle
                                                    id="Ellipse 1031"
                                                    cx="13.4277"
                                                    cy="3.24402"
                                                    r="3"
                                                    fill="#563BFF"
                                                  />
                                                  <circle
                                                    id="Ellipse 1030"
                                                    cx="23.5723"
                                                    cy="3.24402"
                                                    r="3"
                                                    fill="#563BFF"
                                                  />
                                                </g>
                                              </svg>
                                            </DropdownToggle>
                                            <DropdownMenu>
                                              <DropdownItem
                                                onClick={() => {
                                                  //   onEmployeeToUpdateChanged(employee);
                                                  //   decodeAuthozations([...employee.autorizations, ...employee.contact_reasons], employee);
                                                  //   tog_updateEmployeeModal();
                                                }}
                                              >
                                                <svg
                                                  width="20"
                                                  height="20"
                                                  viewBox="0 0 24 24"
                                                  fill="none"
                                                  xmlns="http://www.w3.org/2000/svg"
                                                >
                                                  <path
                                                    d="M21 21L18.4953 18.4953C18.1033 18.1033 17.9073 17.9073 17.7092 17.8311C17.5121 17.7553 17.3684 17.7425 17.161 17.7825C16.9527 17.8226 16.6814 18.0117 16.1387 18.3897C14.6817 19.4048 12.9104 20 11 20C6.02944 20 2 15.9706 2 11C2 6.02944 6.02944 2 11 2C15.9706 2 20 6.02944 20 11C20 12.2414 19.7487 13.4241 19.2941 14.5"
                                                    stroke="#2F384C"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                  />
                                                </svg>{" "}
                                                {props.t("Rechercher")}
                                              </DropdownItem>
                                              {/* <DropdownItem
                                      onClick={() => {
                                        //   setEmployeesEditActions((prevState) => ({
                                        //     ...prevState,
                                        //     [employee.id]: {
                                        //       state: false,
                                        //       loading: true
                                        //     }
                                        //   }));
                                        //   deleteUserRole(employee.id, employee.email);
                                      }}>
                                      {props.t("Supprimer")}
                                    </DropdownItem> */}
                                            </DropdownMenu>
                                          </Dropdown>
                                        )}
                                      </div>
                                    </Col>
                                  </Row>
                                </CardBody>
                              </Card>
                            ))}
                          </div>
                        ))}
                      {fb_posts_loading && (
                        <div className="d-flex">
                          <span
                            className="spinner-border spinner-border-lg mx-auto font-primary"
                            role="status"
                            aria-hidden="true"
                          />
                        </div>
                      )}
                    </div>
                  )}

                <Row className="w-100">
                  {loading && (
                    <span
                      className="spinner-border spinner-border-lg mx-auto font-primary"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                </Row>
              </TabPane>
              <TabPane tabId="2">
                <div>
                  {isFbConnected === undefined ? (
                    <div style={{ textAlign: "center", fontSize: "14px" }}>
                      <Spinner
                        className="me-1"
                        style={{ height: "15px", width: "15px" }}
                        animation="border"
                      />
                      {props.t("Chargement") + "..."}
                    </div>
                  ) : (
                    <div className="row mx-auto col-xxl-9 col-xl-11">
                      <div
                        style={{
                          border: "1px solid",
                          borderColor: "#E9ECEF",
                          borderRadius: "10px",
                          padding: "20px",
                          margin: "0 auto"
                        }}
                      >
                        <div
                          style={{
                            fontWeight: "600",
                            fontSize: "18px",
                            color: isFbConnected === true ? "black" : "#8590a5"
                          }}
                        >
                          1. {props.t("Authentifiez")}
                        </div>
                        {isFbConnected === true ? (
                          <div className="mt-2">
                            {props.t("Connexion effectuée")}{" "}
                            <span style={{ color: "#563BFF" }}>
                              <CheckCircleRounded width={24} height={24} />
                            </span>
                          </div>
                        ) : (
                          <div
                            className="d-flex align-items-center"
                            style={{
                              border: "1px solid",
                              borderColor: "#E9ECEF",
                              borderRadius: "10px",
                              padding: "5px 10px 5px 10px",
                              marginTop: "20px",
                              cursor: "pointer",
                              width: "fit-content"
                            }}
                            onClick={handleLogin}
                          >
                            <i
                              className="mdi mdi-facebook me-1"
                              style={{ fontSize: "22px", color: "#563BFF" }}
                            />{" "}
                            {props.t("Authentification")}
                            {fbAuthLoading && (
                              <span
                                className="spinner-border spinner-border-sm ms-2 font-primary"
                                role="status"
                                aria-hidden="true"
                              />
                            )}
                          </div>
                        )}
                      </div>

                      <div
                        style={{
                          border: "1px solid",
                          borderColor: "#E9ECEF",
                          borderRadius: "10px",
                          padding: "20px",
                          marginTop: "40px",
                          color: isFbConnected === true ? "black" : "#8590a5"
                        }}
                      >
                        <div
                          style={{
                            fontWeight: "600",
                            marginBottom: "10px",
                            fontSize: "18px"
                          }}
                        >
                          2. {props.t("Connectez une page Facebook")}
                        </div>
                        <div>
                          {props.t(
                            "Choisissez une page pour la gestion automatique"
                          )}
                        </div>
                        <div>
                          <div className="d-flex gap-3 align-items-center mt-3">
                            <label
                              className="font-primary mb-0"
                              style={{
                                fontSize: "14px",
                                fontStyle: "normal",
                                fontWeight: "600",
                                lineHeight: "normal",
                                color:
                                  isFbConnected === true ? "black" : "#8590a5"
                              }}
                            >
                              {props.t("Votre Page")} :
                            </label>
                            <Dropdown
                              isOpen={pageDropdown}
                              toggle={() => {
                                if (isFbConnected === true) {
                                  setPageDropdown(!pageDropdown);
                                }
                              }}
                            >
                              <div className="d-flex align-items-center">
                                <DropdownToggle
                                  tag="button"
                                  className="form-control py-0"
                                  style={{ textTransform: "capitalize" }}
                                >
                                  {selectedPage ?? "Sélectionner"}
                                  <i className="ms-2 mdi mdi-chevron-down" />
                                </DropdownToggle>
                                {addLoading && (
                                  <span
                                    className="spinner-border spinner-border-sm ms-2 font-primary"
                                    role="status"
                                    aria-hidden="true"
                                  />
                                )}
                              </div>

                              {fb_pages &&
                              fb_pages.filter(
                                (page) =>
                                  !fb_selected_pages
                                    .map((p) => p.id)
                                    .includes(page.id)
                              ).length > 0 ? (
                                <DropdownMenu className="dropdown-menu-lg-end">
                                  {fb_pages
                                    .filter(
                                      (page) =>
                                        !fb_selected_pages
                                          .map((p) => p.id)
                                          .includes(page.id)
                                    )
                                    .map((page) => (
                                      <DropdownItem
                                        key={page.id}
                                        onClick={() => {
                                          handleAddFBPage(page);
                                        }}
                                      >
                                        <i
                                          className="mdi mdi-facebook me-1"
                                          style={{ fontSize: "18px" }}
                                        />{" "}
                                        {page.name}
                                      </DropdownItem>
                                    ))}
                                </DropdownMenu>
                              ) : (
                                <DropdownMenu className="dropdown-menu-lg-end">
                                  <DropdownItem disabled={true}>
                                    {props.t("Vide")}
                                  </DropdownItem>
                                </DropdownMenu>
                              )}
                            </Dropdown>
                          </div>
                          <div
                            className="mt-3 mb-1"
                            style={{
                              fontWeight: "600",
                              marginBottom: "10px",
                              fontSize: "14px",
                              color: "rgb(86, 59, 255)"
                            }}
                          >
                            <i
                              className="mdi mdi-facebook me-1"
                              style={{ fontSize: "18px" }}
                            />{" "}
                            {props.t("Pages choisies")}
                          </div>
                          {fb_selected_pages && fb_selected_pages.length > 0 ? (
                            <div
                              className="d-flex ps-4"
                              style={{ flexDirection: "column", width: "80%" }}
                            >
                              {fb_selected_pages.map((page) => (
                                <Card
                                  className="user-card font-primary"
                                  style={{
                                    borderLeft: "5px solid #563BFF",
                                    marginBottom: "12px",
                                    borderRadius: "10px",
                                    boxShadow:
                                      "0px 6px 10px 1px rgba(53, 22, 252, 0.1)",
                                    paddingTop: "6px",
                                    paddingRight: "29px",
                                    paddingBottom: "10px",
                                    paddingLeft: "16px",
                                    color: "black"
                                  }}
                                >
                                  <CardBody className="p-0">
                                    <Row>
                                      <Col
                                        md={5}
                                        className="d-flex align-items-center"
                                        style={{ fontWeight: "600" }}
                                      >
                                        {page.name}
                                      </Col>
                                      <Col
                                        md={5}
                                        className="d-flex align-items-center"
                                        style={{ fontWeight: "600" }}
                                      >
                                        {page.category}
                                      </Col>
                                      <Col
                                        md={2}
                                        className="align-items-center"
                                      >
                                        <button
                                          onClick={(e) => {
                                            handleRemoveFBPage(page.id);
                                          }}
                                          className="p-0"
                                          style={{
                                            background: "none",
                                            border: "none",
                                            color: "#F10944",
                                            float: "inline-end"
                                          }}
                                        >
                                          {deleteLoading[page.id] ? (
                                            <span
                                              className="spinner-border spinner-border-sm ms-2 font-primary"
                                              role="status"
                                              aria-hidden="true"
                                            />
                                          ) : (
                                            <CrossOutlined
                                              width={20}
                                              height={20}
                                            />
                                          )}
                                        </button>
                                      </Col>
                                    </Row>
                                  </CardBody>
                                </Card>
                              ))}
                            </div>
                          ) : loading ? (
                            <div
                              className="d-flex justify-content-center"
                              style={{ width: "80%" }}
                            >
                              <span
                                className="spinner-border spinner-border-sm mx-auto font-primary"
                                role="status"
                                aria-hidden="true"
                              />
                            </div>
                          ) : (
                            <div className="text-center">{props.t("Vide")}</div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </TabPane>
            </TabContent>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(FacebookPage);
